// extracted by mini-css-extract-plugin
export default {"container":"container___is9xg","text_container":"text_container___ZcqtI","header":"header___EC2rP","image_container":"image_container___A0Ila"};